<template>
    <div class="container">
        <div class="img-sd" crossorigin="anonymous" v-bind:style='{ backgroundImage: "url(" + imgUrl + ")", }'>
        </div>
        <!-- <div><img crossorigin="anonymous" :src="imgUrl" style="width:100%;height:100px" class="mb-2" alt="recipe image" /></div> -->
        <p class="text-center font-weight-bold font32 mt-3 text-capitalize">{{name}}</p>
        <p class="text-center font-weight-bold">{{origin}}</p>
        <b-row class="recipecard">
            <b-col cols="12">
                <div class="p-3 mb-2">
                    <p class="font-weight-bold text-center culture-primary">About the recipe</p>
                    <span :inner-html.prop="storyLine"></span> 
                </div>
            </b-col>
            <b-col cols="12">
                <div class="box box-left p-3">
                    <p class="font-weight-bold  culture-primary">Details</p>
                    <p class="culture-secondary font12">more details about the recipe</p>
                    <p>Preparation Time: {{prepTime}}</p>
                    <p>Cook Time: {{cookTime}}</p>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div class="box box-grey box-left p-4">
                    <p class="font-weight-bold culture-secondary">Ingredients</p>
                    <div class="mt-4">
                        <ul>
                            <li v-for="(ing, index) in ingredients" :key="index+ing">
                                <b-icon shift-v="-3" font-scale="1" icon="check-all"></b-icon> {{ing.item}}
                            </li>
                        </ul>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div class="box box-left p-4">
                    <p class="font-weight-bold  culture-primary">Instructions</p>
                    <p class="culture-secondary font14">Steps in preparing the recipe</p>
                    <div v-for="(ins, index) in instructions" :key="index+ins">
                        <div class="culture-primary">
                            <b-icon icon="check-circle-fill" font-scale="0.9"></b-icon> Step {{index+1}}
                        </div>
                        <div class="mt-2 mb-3">{{ins.step}}</div>
                    </div>

                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'recipe-card',
    props: ['name', 'prepTime', 'cookTime', 'origin', 'instructions', 'ingredients', 'storyLine', 'imgUrl'],
}
</script>

<style scoped>
.col {
    padding-right: 0 !important;
    padding-left: 0 !important;
    ;
}

.row {
    margin-right: 0 !important;
    margin-left: 0 !important;
}

.recipecard {
    border: none !important;
    background: #FCFCFC;
    position: relative;
}

.img-sd {
    height: 11rem;
    background-size: cover;
    background-position: center;
}

.box {
    min-height: 12rem;
    height: auto
}

.b-icon {
    z-index: 1000 !important;
}

.box-grey {
    background-color: #e7e7e7;
}

.box-yellow {
    background-color: #ffdfa7;
}
</style>
